var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60162 14.0946C11.2476 14.0946 14.2032 11.1633 14.2032 7.5473C14.2032 3.93133 11.2476 1 7.60162 1C3.95565 1 1 3.93133 1 7.5473C1 11.1633 3.95565 14.0946 7.60162 14.0946Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60256 13.5921C10.9686 13.5921 13.6973 10.8859 13.6973 7.54752C13.6973 4.20918 10.9686 1.50293 7.60256 1.50293C4.23652 1.50293 1.50781 4.20918 1.50781 7.54752C1.50781 10.8859 4.23652 13.5921 7.60256 13.5921Z",
    stroke: "#8780ab",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyRing);
export default __webpack_public_path__ + "static/media/grey-ring.9e8a3d4c175e0a0bc4387cc605d1b43e.svg";
export { ForwardRef as ReactComponent };